// Copyright (c) 2016 Deere & Company

import OpenPartReturns from './components/open-part-requests';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../shared/services/get-date-format';

const getStateToBindToContainerProps = state => ({
    allPartReturnsCount: state.partReturns.allPartReturns.partReturns.length,
    busyCounter: state.partReturns.openPartReturns.busyCounter,
    exportToExcel: state.exportToExcel,
    facets: {
        ...state.partReturns.openPartReturns.facets,
        dealerAccountsFacet: {
            ...state.partReturns.openPartReturns.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        },
        requestDateFacet: {
            ...state.partReturns.openPartReturns.facets.requestDateFacet,
            dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key)
        }
    },
    hasSearchResultsLoaded: !state.partReturns.search.facets.isInitialLoad,
    openPartReturns: state.partReturns.openPartReturns.partReturns,
    searchByDropdown: state.partReturns.search.searchByDropdown,
    searchFilters: state.partReturns.openPartReturns.searchFilters,
    searchQueryString: state.partReturns.search.searchQueryString,
    searchResultsCount: state.partReturns.search.filteredSearchResults.length
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(OpenPartReturns);



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/state-connector.js